export default "__VITE_ASSET__BdGlfxUi__"